import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import MerchantForm from "./MerchantComponents/MerchantForm";

import { useAddMerchantMutation } from "store/services/merchantApi";

const MerchantCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Merchants", path: "/app/crm/merchant/list" },
    { title: "New Merchant" },
  ];

  // RTK query hook for adding a new merchant
  const [addMerchant, { isLoading }] = useAddMerchantMutation();

  const handleCreateMerchant = async (data) => {
    try {
      const { _id } = await addMerchant(data).unwrap();
      toast.success("Merchant successfully created!");
      navigate(`/app/crm/merchant/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Merchant!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <MerchantForm
          isBusy={isLoading}
          onSubmit={handleCreateMerchant}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default MerchantCreateScreen;